import { Provider, isDevMode } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './loaders/transloco-http-loader';

/**
 * Provides Transloco configuration for the application
 *
 * Usage in app.config.ts or assets-overview.ts:
 * ```typescript
 * import { provideI18n } from '@frontend-mono/shared/i18n';
 *
 * bootstrapApplication(App, {
 *   providers: [
 *     provideI18n(),
 *     // ... other providers
 *   ]
 * });
 * ```
 */
export function provideI18n(languages = ['en', 'fr'], defaultLang = 'en', fallbackLang = 'en'): Provider[] {
  return [
    provideTransloco({
      config: {
        availableLangs: languages,
        defaultLang: defaultLang,
        fallbackLang: fallbackLang,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: true,
          logMissingKey: true,
          allowEmpty: false,
        }
      },
      loader: TranslocoHttpLoader,
    }),
  ];
}
